module.exports = __webpack_public_path__ + "img/panelView_blueBg_2_3_wx.10fbaba5.png";